import { computed, type ComputedRef } from 'vue'
import { useSamudkoyStore } from '../../stores/samudkoy'

interface UseButtonTranslate {
  show: ComputedRef<boolean>
  disabled: ComputedRef<boolean>
  doPopupTranslateOpen: Function
}

//------------------------------------------------
export function useButtonTranslate(): UseButtonTranslate {
  const samudkoyStore = useSamudkoyStore()

  const show = computed(() => !samudkoyStore.translate)
  const disabled = computed(() => !samudkoyStore.hasTranslate)

  function doPopupTranslateOpen() {
    samudkoyStore.translateOn()
  }

  return {
    show,
    disabled,
    doPopupTranslateOpen,
  }
}

//------------------------------------------------
export function useButtonTranslateMock(): UseButtonTranslate {
  const show = computed(() => true)
  const disabled = computed(() => false)

  function doPopupTranslateOpen() {
    console.debug('doPopupTranslateOpen()')
  }

  return {
    show,
    disabled,
    doPopupTranslateOpen
  }
}
